import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import React, { useEffect } from 'react'
import { FaSuitcaseRolling, FaCircleInfo } from 'react-icons/fa6';

const FareOptionsSelectRadio = (props) => {
  const { flight, value, onValueChange, compId, currentFlightInfo, listview = false, onInfoClick } = props;
  const fareLength = flight.FareOptions && flight.FareOptions.length;

  return (
    flight.FareOptions && <div className='ml-0 lg:ml-1 w-full'>
      <RadioGroup
        onValueChange={onValueChange}
        value={value}
        className={cn(
          listview && 'flex-col',
          'flex flex-wrap gap-2 lg:gap-3 items-stretch justify-end'
        )}
      >
        {flight.FareOptions.map((option, i) => {
          const isSelected = value === option.BookingKey;
          const adtFare = option.FareBreakDowns?.find(fb => fb.Passenger.Code === 'ADT');
          const baggageInfo = adtFare?.Baggages?.find(bg => bg.BagType === 'Luggage' || bg.BagType === 'Checked');

          return (
            <div
              key={option.BookingKey}
              className={cn(
                "relative flex flex-col p-2.5 border-2 rounded-lg transition-all cursor-pointer w-[160px] shrink-0",
                isSelected
                  ? "border-primary bg-primary/5 shadow-sm ring-1 ring-primary/5"
                  : "border-border hover:border-muted-foreground/20 bg-card/40"
              )}
              onClick={() => onValueChange(option.BookingKey)}
            >
              <div className="flex justify-between items-start mb-1.5">
                {fareLength > 1 && (
                  <RadioGroupItem
                    value={option.BookingKey}
                    id={compId + flight.Id + option.BookingKey}
                    className="h-4 w-4 border-2 border-muted-foreground/30 data-[state=checked]:border-primary"
                  />
                )}
              </div>

              <Label
                className="flex flex-col cursor-pointer flex-1"
                htmlFor={compId + flight.Id + option.BookingKey}
              >
                <span className='block text-[10px] text-muted-foreground uppercase font-bold tracking-widest mb-1'>
                  {option.FareType}
                </span>

                <div className='flex flex-col mb-1.5'>
                  <span className='text-[10px] font-semibold text-muted-foreground uppercase leading-none'>{option.Currency}</span>
                  <span className="text-xl font-bold tracking-tight">{(option.GTotalFare || 0).toLocaleString()}</span>
                </div>

                {baggageInfo && (
                  <div className="py-1 flex items-center text-xs font-bold text-muted-foreground mb-2 bg-muted/60 w-fit px-2 rounded-sm">
                    <FaSuitcaseRolling className="me-2 h-3.5 w-3.5" />
                    <span>
                      {baggageInfo.Quantity} {baggageInfo.Unit}
                    </span>
                  </div>
                )}
              </Label>

              <div className="mt-auto">
                <Button
                  variant="outline"
                  size="sm"
                  className="w-full flex items-center justify-center gap-1.5 text-[10px] font-bold h-7 rounded-md border-muted-foreground/10 hover:bg-primary/5 hover:text-primary hover:border-primary/20 transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onInfoClick && onInfoClick();
                  }}
                >
                  <FaCircleInfo className="text-[11px]" />
                  Fare Rules
                </Button>
              </div>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}

export default FareOptionsSelectRadio


